var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLineTop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1876,
    height: 2,
    viewBox: "0 0 1876 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.714 0H110.362V2H220.714V0Z",
    fill: "#D2963F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.352 0H0V2H110.352V0Z",
    fill: "#E51A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.409 0H331.057V2H441.409V0Z",
    fill: "#BB262D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.057 0H220.705V2H331.057V0Z",
    fill: "#529947"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.114 0H551.762V2H662.114V0Z",
    fill: "#00B8D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.762 0H441.409V2H551.762V0Z",
    fill: "#E73E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.819 0H772.467V2H882.819V0Z",
    fill: "#952846"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.467 0H662.114V2H772.467V0Z",
    fill: "#F5B320"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.53 0H993.181V2H1103.53V0Z",
    fill: "#D7156C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.171 0H882.819V2H993.171V0Z",
    fill: "#EA6730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1324.24 0H1213.89V2H1324.24V0Z",
    fill: "#B18033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1213.89 0H1103.53V2H1213.89V0Z",
    fill: "#F08E31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1544.94 0H1434.59V2H1544.94V0Z",
    fill: "#0090CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1434.59 0H1324.24V2H1434.59V0Z",
    fill: "#437D43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1765.65 0H1655.3V2H1765.65V0Z",
    fill: "#006A95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1876 0H1765.65V2H1876V0Z",
    fill: "#1D4668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1655.3 0H1544.94V2H1655.3V0Z",
    fill: "#62B346"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1876,
    height: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineTop);
export default __webpack_public_path__ + "static/media/LineTop.5a67f6a8c1cebe53f335eada92455fc6.svg";
export { ForwardRef as ReactComponent };